<template>
  <div class="global-loader-container">
    <!-- Top Progress Bar -->
    <v-no-ssr>
      <div v-if="generalStore.loading" class="top-progress-bar">
        <div class="progress-glow"></div>
      </div>
    </v-no-ssr>

    <!-- Minimal Blur Overlay -->
    <v-overlay
      :model-value="generalStore.loading"
      class="align-center justify-center global-loader-overlay"
      persistent
      scrim="#F8FAFC"
      :opacity="0.3"
      z-index="9999"
      transition="fade-transition"
    >
      <div class="loader-content">
        <div class="premium-loader">
          <div class="spinner-ring outer"></div>
          <div class="spinner-ring mid"></div>
          <div class="spinner-ring inner"></div>
          <img
            src="@/assets/images/layout/omd-logo.png"
            class="loader-logo"
            alt="OMD Live"
          />
        </div>
        <div class="loading-status">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script setup>
import { useGeneralStore } from "@/stores/general";
const generalStore = useGeneralStore();
</script>

<style scoped>
.global-loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10000;
  pointer-events: none;
}

/* Top Progress Bar Implementation */
.top-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 3px;
  width: 100%;
  background: linear-gradient(90deg, #1f293b, #2e9c94, #1f293b);
  background-size: 200% 100%;
  animation: progress-slide 1.5s infinite linear;
  box-shadow: 0 1px 10px rgba(46, 156, 148, 0.4);
}

.progress-glow {
  position: absolute;
  right: 0;
  width: 100px;
  height: 100%;
  background: linear-gradient(90deg, transparent, #2e9c94, transparent);
  filter: blur(2px);
}

@keyframes progress-slide {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Overlay & Content Styling */
.global-loader-overlay {
  backdrop-filter: blur(12px) saturate(180%);
  pointer-events: auto;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.premium-loader {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-logo {
  width: 50px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 0 8px rgba(0, 54, 63, 0.1));
  z-index: 2;
  animation: logo-pulse 2s ease-in-out infinite;
}

.spinner-ring {
  position: absolute;
  border-radius: 50%;
  border: 2px solid transparent;
}

.spinner-ring.outer {
  width: 110px;
  height: 110px;
  border-top-color: #00363f;
  border-bottom-color: #2e9c94;
  animation: spin 2.5s linear infinite;
}

.spinner-ring.mid {
  width: 90px;
  height: 90px;
  border-left-color: #1f293b;
  border-right-color: rgba(46, 156, 148, 0.5);
  animation: spin-reverse 2s linear infinite;
  opacity: 0.7;
}

.spinner-ring.inner {
  width: 70px;
  height: 70px;
  border-top-color: #2e9c94;
  animation: spin 1.5s ease-in-out infinite;
  opacity: 0.5;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spin-reverse {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

@keyframes logo-pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
}

/* Loading Dots Animation */
.loading-status {
  display: flex;
  gap: 6px;
}

.dot {
  width: 8px;
  height: 8px;
  background-color: #00363f;
  border-radius: 50%;
  animation: dot-loading 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}
.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes dot-loading {
  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
